import { put } from 'core/middlewares/utilities';
import { user, utilities } from 'core/use-cases';
import { isPublicRoute } from './getters/getters';
import { history } from 'core/use-cases/utilities';

/**
 * Broker responsible for indicating whether or not the application can be started.
 *
 */

export function* preflightFlow(action: utilities.ActionSuccess) {
  const { payload: isTapume = false } = action;
  const isPublic: boolean = yield isPublicRoute();

  if (isTapume) {
    history.push('/indisponivel');

    return;
  }

  if (isPublic) {
    return;
  }

  yield put(user.actions.userResaleIntention.request());
}
